import { render, staticRenderFns } from "./general-report.vue?vue&type=template&id=c2516fca"
import script from "./general-report.vue?vue&type=script&lang=js"
export * from "./general-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports